/* SearchEmbedded.tsx generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { media } from '@atlaskit/primitives/responsive';
import React from 'react';
import { SearchDropdownEmbedded } from '../SearchDropdown';
const _6 = "@media (min-width:64rem){._dbjgidpf{margin-top:0}._1hvk1kvb{margin-right:8.5%}._isu4idpf{margin-bottom:0}._15qm1kvb{margin-left:8.5%}._pdlmhiv4{gap:var(--ds-space-400)}}";
const _5 = "._kqswh2mm{position:relative}";
const _4 = "._zulp1b66{gap:var(--ds-space-050,4px)}";
const _3 = "._4cvr1y6m{align-items:flex-start}";
const _2 = "._2lx21bp4{flex-direction:column}";
const _ = "._1e0c1txw{display:flex}";
const SearchEmbeddedWrapper = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4, _5, _6]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c1txw _2lx21bp4 _4cvr1y6m _zulp1b66 _kqswh2mm _dbjgidpf _1hvk1kvb _isu4idpf _15qm1kvb _pdlmhiv4", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  SearchEmbeddedWrapper.displayName = 'SearchEmbeddedWrapper';
}
export const SearchEmbedded = _ref2 => {
  let {
    inputWidth
  } = _ref2;
  return /*#__PURE__*/React.createElement(SearchEmbeddedWrapper, null, /*#__PURE__*/React.createElement(SearchDropdownEmbedded, {
    inputWidth: inputWidth
  }));
};